
import './Weather.css';
import { useSelector } from 'react-redux';
const Weather = () => {
  const {userInfo} = useSelector((state:any) => state.auth);
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '36px',
        marginBottom: 20,
      }}
    >
      {/* {this.state.isProgress ? this.progress() : this.weatherContent()} */}
      {userInfo?.first_name + ' ' + userInfo?.last_name}
    </div>
  );
};

export default Weather;